package com.trevorwiebe.timesheet.payPeriod.presentation.uiUtils

enum class TimeSheetStatus(val title: String) {
    CURRENT_PERIOD("Current Period"),
    CONFIRM_HOURS_NOW("Unsubmitted"),
    CONFIRMED("Submitted"),
    PERIOD_CLOSED("Pay Period Closed")
}
